// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import './styles/globals.css';

// Context Providers
import { AppProvider } from './context/AppContext';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';

// Layout
import PublicLayout from './shared/components/layout/PublicLayout';

// Pages
import Landing from './pages/Landing';
import KganyaScents from './pages/KganyaScents';
import ProductDetail from './pages/ProductDetail';
import Checkout from './pages/Checkout';
import Profile from './pages/Profile';
import Films from './pages/Films';
import Farming from './pages/Farming';

// Payment Pages
import PaymentSuccess from './pages/payment/PaymentSuccess';
import PaymentCancelled from './pages/payment/PaymentCancelled';

// Admin Components
import {
  AdminLogin,
  AdminDashboard,
  AdminProducts,
  AdminOrders,
  AdminProductForm,
  AdminCategories,
  AdminAnalytics,
  AdminSettings,
  AdminLayout,
  ProtectedRoute
} from './features/admin';

const RedirectOctoberProduct = () => {
  const { productId } = useParams();
  return <Navigate to={`/kganya-scents/product/${productId}`} replace />;
};

function App() {
  return (
    <AppProvider>
      <AuthProvider>
        <CartProvider>
          <Router>
            <div className="App">
              <Routes>
              {/* Public Routes with Header/Footer */}
              <Route path="/" element={<PublicLayout><Landing /></PublicLayout>} />
              <Route path="/october" element={<Navigate to="/kganya-scents" replace />} />
              <Route path="/kganya-scents" element={<PublicLayout><KganyaScents /></PublicLayout>} />
              <Route path="/october/product/:productId" element={<RedirectOctoberProduct />} />
              <Route path="/kganya-scents/product/:productId" element={<PublicLayout><ProductDetail /></PublicLayout>} />
              <Route path="/checkout" element={<PublicLayout><Checkout /></PublicLayout>} />
              <Route path="/profile" element={<PublicLayout><Profile /></PublicLayout>} />
              <Route path="/films" element={<PublicLayout><Films /></PublicLayout>} />
              <Route path="/farming" element={<PublicLayout><Farming /></PublicLayout>} />
              
              {/* Payment Routes with Header/Footer */}
              <Route path="/payment/success" element={<PublicLayout><PaymentSuccess /></PublicLayout>} />
              <Route path="/payment/cancelled" element={<PublicLayout><PaymentCancelled /></PublicLayout>} />
              <Route path="/payment/failed" element={<PublicLayout><PaymentCancelled /></PublicLayout>} />
              
              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              
              {/* Protected Admin Routes */}
              <Route path="/admin" element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }>
                <Route path="dashboard" element={<AdminDashboard />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="products/new" element={<AdminProductForm />} />
                <Route path="products/:id/edit" element={<AdminProductForm />} />
                <Route path="categories" element={<AdminCategories />} />
                <Route path="orders" element={<AdminOrders />} />
                <Route path="analytics" element={<AdminAnalytics />} />
                <Route path="settings" element={<AdminSettings />} />
              </Route>
              
              {/* Redirect /admin to /admin/dashboard */}
              <Route path="/admin" element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              } />
              </Routes>
            </div>
          </Router>
        </CartProvider>
      </AuthProvider>
    </AppProvider>
  );
}

export default App;
